import { getBlotOuterOpacity } from './index'

const killStale = ({ mouseUp, duration }) =>
  !mouseUp || Date.now() - mouseUp < duration

export function Store(publicize) {
  let _data = []
  let _playing = false
  let _frame

  const Store = {
    each(callback, scope) {
      for (let i = 0, l = _data.length; i < l; i++) {
        callback.call(scope, _data[i])
      }
    },

    play() {
      if (!_playing) {
        _playing = true
        Store.update()
      }
    },

    stop() {
      _playing = false
      cancelAnimationFrame(_frame)
    },

    getTotalOpacity(opacity) {
      let answer = 0

      for (let i = 0, l = _data.length; i < l; i++) {
        answer += getBlotOuterOpacity(_data[i], opacity)
      }

      return answer
    },

    update() {
      _data = _data.filter(killStale)

      if (_data.length) {
        _frame = requestAnimationFrame(Store.update)
      } else {
        Store.stop()
      }

      publicize()
    },

    add(props) {
      _data.push(props)
      Store.play()
    },

    release(time) {
      for (let i = _data.length - 1; i >= 0; i--) {
        if (!_data[i].mouseUp) {
          return (_data[i].mouseUp = time)
        }
      }
    }
  }

  return Store
}
